import { IColumn } from '@fluentui/react';
import { centerAlignHeaderStyle, rightAlignHeaderStyle } from 'common/utils/columnUtilities';

export const columns: IColumn[] = [
  {
    key: 'fileReference',
    name: 'File',
    fieldName: 'fileReference',
    minWidth: 120,
    maxWidth: 140,
    isResizable: true,
  },
  {
    key: 'indexName',
    name: 'Name',
    fieldName: 'indexName',
    minWidth: 120,
    maxWidth: 130,
    isResizable: true,
  },
  {
    key: '_documentContents',
    name: 'Description',
    fieldName: '_documentContents',
    minWidth: 120,
    maxWidth: 130,
    isResizable: true,
  },
  {
    key: 'indexReferenceNumber',
    name: 'Number',
    fieldName: 'indexReferenceNumber',
    minWidth: 90,
    maxWidth: 100,
    isResizable: true,
  },
  {
    key: 'amount',
    name: 'Amount',
    fieldName: 'amount',
    minWidth: 90,
    maxWidth: 100,
    isResizable: true,
    styles: rightAlignHeaderStyle,
  },
  {
    key: 'action',
    name: 'Action',
    fieldName: 'action',
    minWidth: 90,
    maxWidth: 90,
    isResizable: true,
    styles: centerAlignHeaderStyle,
  },
];
